import widgetRoutes from 'enums/routes'
import Link from 'next/link'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import Layout from 'library/atoms/Layout'
import styled from '@emotion/styled'
import { TopLevelCard } from 'helpers/determineTopLevelChargeableData'
import { DEFAULT_TITLES } from 'enums/topLevelChargeables'
import { SetActiveModalId } from 'shared/library/molecules/Modal'
import PoweredByEola from 'library/atoms/PoweredByEola'

export interface MenuProps {
  menuLinks?: TopLevelCard[]
  outletSlug?: string
  setActiveModalId: SetActiveModalId<null>
  widgetSlug: string
}

const Menu = ({
  menuLinks,
  outletSlug,
  setActiveModalId,
  widgetSlug
}: MenuProps) => {
  const { t } = useTranslation('common')

  const COMMON_PROPS = { onNavigate: () => setActiveModalId(null) }

  return (
    <StyledLayout>
      <StyledNav>
        <StyledMenuLink
          href={widgetRoutes.HOME.url({ widgetSlug })}
          passHref
          {...COMMON_PROPS}
        >
          {t('home')}
        </StyledMenuLink>
        {outletSlug && (
          <StyledMenuLink
            href={widgetRoutes.OUTLET.url({ outletSlug })}
            passHref
            {...COMMON_PROPS}
          >
            {t('about-us')}
          </StyledMenuLink>
        )}
        {menuLinks?.map(({ href, title }) => (
          <StyledMenuLink href={href} key={title} passHref {...COMMON_PROPS}>
            {DEFAULT_TITLES.some(x => x === title)
              ? t(title.toLowerCase())
              : title}
          </StyledMenuLink>
        ))}
      </StyledNav>
      <PoweredByEola />
    </StyledLayout>
  )
}

export default Menu

const StyledNav = styled.nav(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.space[8],
  padding: theme.mixins.pxSpread([theme.space[6], theme.space[4]])
}))

const StyledMenuLink = styled(Link)(({ theme }) => ({
  ...theme.fontStyle.h5,
  textDecoration: 'none',
  '&:first-of-type': {
    marginTop: 0
  },
  '&:last-of-type': {
    marginBottom: 0
  }
}))

const StyledLayout = styled(Layout)(() => ({
  width: '100%'
}))
